<template>
  <div>
    <div class="m-title">{{ conf.title || '无' }}</div>

    <div class="board-box" v-loading="loading">
      <select-range :brand-data="filterList" @range-change="rangeChange" />
      <div :id="chartId" class="chart1"></div>
    </div>
  </div>
</template>

<script>
import common from './mixins/common'

/**
 * 柱形图
 */
export default {
  mixins: [common],
  name: 'ChartBar2',
  props: {
    source: { type: String, default: '' }
  },
  data() {
    return {
      /** 是否需要更新 Brand 列表 */
      isUpdateFilter: true,
      filterList: [],
      chartData: {},
      /** 服务器原始数据 */
      sourceList: []
    }
  },
  computed: {
    conf: function() {
      /**
       * 不同 source 下配置数据
       * - fieldConf 整理数据时，字段配置
       * - filedConf.filterField 品牌下拉字段
       */
      const Map = {
        accept: {
          title: '现场工程师按品牌工单类型统计-接单数量',
          fieldConf: {
            mField: 'WORK_ORDER_TYPE_DESC',
            xField: 'ENGINEER_NAME',
            filterField: 'BRAND_NAME'
          }
        },
        finish: {
          title: '现场工程师按品牌工单类型统计-完成现场单数量',
          fieldConf: { mField: 'WORK_ORDER_TYPE_DESC', xField: 'ENGINEER_NAME', filterField: 'BRAND_NAME' }
          // fieldConf: { mock: true, mField: 'stage', xField: 'name', filterField: 'brand' }
        }
      }

      return Map[this.source] || {}
    }
  },
  watch: {
    chartData: function() {
      this.updateChart()
    }
  },
  mounted: function() {
    this.getData()
  },
  methods: {
    updateChart: function() {
      let chartData = this.chartData,
        conf = this.conf
      let options = {
        legend: {
          type: 'scroll',
          orient: 'vertical',
          right: '20',
          top: '55',
          bottom: '20',
          data: chartData.legend
        },
        series: chartData.series,
        xAxis: [
          {
            type: 'category',
            triggerEvent: conf.triggerLabel,
            boundaryGap: true,
            data: chartData.xAxis || []
          }
        ],
        yAxis: [
          {
            type: 'value',
            scale: true,
            name: '（个）',
            boundaryGap: [0.2, 0.2],
            min: 0,
            minInterval: 1
          }
        ],
        dataZoom: {
          show: true,
          start: 0,
          // end: 50,
          end: (10 * 100) / chartData.xAxis.length,
          height: 15
        },
        grid: { right: 130 },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        toolbox: {
          show: false,
          feature: {
            dataView: { readOnly: false },
            restore: {},
            saveAsImage: {}
          }
        }
      }

      /** @type {import('echarts').ECharts} */
      let chartIns = this.chartIns
      chartIns && chartIns.setOption(options, true)
    },

    /**
     * 处理数据
     * @param {[]} list
     */
    processList(list) {
      let { mField, xField, filterField } = this.conf.fieldConf

      let filterMap = {},
        filterList = []

      let series = [],
        xAxis = [],
        legend = [],
        total = 0

      let multiColMap = {},
        categoryMap = {}

      list.map(v => {
        let curX = v[xField],
          m = v[mField],
          b = v[filterField]

        if (!filterMap[b]) {
          filterMap[b] = true
          filterList.push({ label: b, value: b })
        }

        /** 某个 legend：集成、改造等 */
        if (!multiColMap[m]) multiColMap[m] = true

        if (!categoryMap[curX]) categoryMap[curX] = {}
        if (!categoryMap[curX][m]) categoryMap[curX][m] = []

        categoryMap[curX][m].push(v)
      })

      legend = Object.keys(multiColMap)

      xAxis = Object.keys(categoryMap)
      series = legend.map(m => {
        let cList = xAxis.map(curX => {
          let n = (categoryMap[curX][m] || []).reduce((total, cur) => (total += 1), 0)

          total += n
          return {
            name: [curX, m].join(','),
            value: n
          }
        })

        return {
          name: m,
          type: 'bar',
          stack: '广告',
          emphasis: {
            focus: 'series'
          },
          barMaxWidth: '14',
          // barMinHeight: 10,
          data: cList
        }
      })

      this.chartData = { legend, xAxis, series, total }

      if (this.isUpdateFilter) {
        this.filterList = filterList
        this.isUpdateFilter = false
      }
    },

    /**
     * 获取数据
     * @param {import('./SelectRange.vue').IRange} range 选择日期、品牌、工程师
     */
    getData: function(range) {
      let condition = this.condition,
        /** @type {import('../index.vue').IRoleId */
        roleId = this.roleId,
        { mock, filterField, timeField = 'YW_SERVICE_ORDER_CREATE_TIME' } = this.conf.fieldConf

      if (range) {
        if (range.type === 'date') {
          const tf = 'YYYY-MM-DD'
          // 日期变化
          let [start = '', end = ''] = range.data.current
          if (start === end) {
            // LIKE
            condition[`${timeField}:2`] = start + '%'
          } else {
            // <= 接口不包含此临界值，故需 +1 或者拼接时分秒
            end = moment(end)
              .add(1, 'day')
              .format(tf)

            condition[`${timeField}:5`] = start
            condition[`${timeField}:6`] = end
          }
          if (!start && !end) {
            delete condition[`${timeField}:2`]
            delete condition[`${timeField}:5`]
            delete condition[`${timeField}:6`]
          }
        } else if (range.type === 'brand') {
          let /** filter value */ fv = range.data.current,
            sourceList = this.sourceList

          let list = fv ? sourceList.filter(v => v[filterField] === fv) : sourceList
          this.isUpdateFilter = false

          this.processList(list)
          return
        }
      }

      this.loading = true
      let requestFn = ''
      if (this.source === 'accept') {
        condition['SERVICE_STATE:1'] = '2,3,4,5,6,7,8,9,10'
        requestFn = this.api.queryList('YW_SERVICE_ORDER_V1', { p2: condition, p9: '' }, `${roleId}_chart_2_accept`)
      } else if (this.source === 'finish') {
        condition['SERVICE_STATE:1'] = '7'
        requestFn = this.api.queryList('YW_SERVICE_ORDER_V1', { p2: condition, p9: '' }, `${roleId}_chart_3_finish`)
      }
      requestFn.then(
        res => {
          this.loading = false
          let resData = (this.sourceList = res.result)

          // TODO: 模拟数据
          if (mock) {
            resData = this.sourceList = this.genTableData(100)
          }

          this.isUpdateFilter = true
          this.processList(resData)
        },
        err => {
          this.loading = false
        }
      )
    }
  }
}
</script>

<style lang="postcss"></style>



// WEBPACK FOOTER //
// src/components/viewBoard/components/ChartBar2.vue